





























import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { microsoftWebservice } from '@/webservices/microsoft';
import { FormState } from '@/components/prine/enums/FormState';
import type { MsUser } from '@/models/msUser';

@Component({
    name: 'SelectMsUsers',
})
export default class SelectMsUsers extends Vue {
    public FormState = FormState;

    @Prop({
        type: Number,
        default: () => FormState.New,
    })
    private state: FormState;

    @Prop() private disabled: boolean;
    @Prop() private isDesktop: boolean;
    @Prop() private projectMsUsers: MsUser[];

    private selectedMsUsersData: MsUser[] = [] as MsUser[];
    private msUsers: MsUser[] = [] as MsUser[];

    @Watch('disabled')
    private onDisabledValueChange() {
        this.init();
    }

    // Mounted is called initially
    private mounted() {
        this.init();
    }

    private init() {
        if (!this.disabled) {
            this.loadMsUsers();
            this.selectedMsUsersData = JSON.parse(JSON.stringify(this.projectMsUsers));
        }
    }

    private loadMsUsers() {
        microsoftWebservice
            .getUsers()
            .then((res) => {
                this.msUsers = res.data;
                // Map MS id back so we know which user is selected in the multiselect
                this.msUsers.forEach((msUser) => (msUser.ms_id = msUser.id.toString()));
            })
            .catch((err) => {
                console.log(err);
            });
    }
    private fullname({ firstname, lastname, email }) {
        return `${firstname || '-'} ${lastname} (${email})`;
    }
}
